import { defineRecipe } from '@chakra-ui/react';
export const badgeRecipe = defineRecipe({
    base: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        whiteSpace: 'nowrap',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        fontFamily: 'heading',
        letterSpacing: '0.045em',
        verticalAlign: 'middle',
        colorPalette: 'lilac',
        // A status read as a word, on any variant: normal case, 12 px, no tracking
        // (the UGC surfaces). Asked with `data-casing="word"` because the
        // variant axis already carries the fill, and the casing is independent of it.
        "&[data-casing='word']": {
            textTransform: 'none',
            letterSpacing: 'normal',
            fontWeight: 'semibold',
            fontSize: '12px',
        },
    },
    variants: {
        variant: {
            solid: {
                bg: 'colorPalette.solid',
                color: 'colorPalette.contrast',
            },
            outline: {
                border: '1px solid',
                borderColor: 'colorPalette.emphasized',
                color: 'colorPalette.solid',
                // Chakra's own outline badge draws an inset ring; with the border above
                // it doubled the hairline.
                boxShadow: 'none',
            },
            subtle: {
                bg: 'colorPalette.subtle',
                color: 'colorPalette.fg',
            },
            // A status read as a word rather than as a label: normal case, no
            // tracking, hairline frame. Used by the companion blocks ("Brouillon",
            // "Expire bientôt") with `colorPalette="agent"` / `"agent.warning"`.
            // A new variant on purpose: `surface` keeps Chakra's default for the
            // badges already using it (affiliate portal).
            word: {
                textTransform: 'none',
                letterSpacing: 'normal',
                fontWeight: 'semibold',
                borderWidth: '1px',
                borderColor: 'colorPalette.emphasized',
                bg: 'colorPalette.muted',
                color: 'colorPalette.fg',
            },
            // The creator space's state pill (Collab Portal): the word in normal
            // case, dark on a pale ground the caller picks from its tone.
            pill: {
                textTransform: 'none',
                letterSpacing: '0',
                fontWeight: 'semibold',
                color: 'primary.900',
                lineHeight: '1',
                flexShrink: 0,
            },
        },
        size: {
            xs: {
                fontSize: '8px',
                px: '1.5',
                rounded: 'xs',
            },
            sm: {
                fontSize: '10.5px',
                px: '2',
                rounded: 'sm',
                h: '22px',
            },
            md: {
                fontSize: '12px',
                px: '2.5',
                rounded: 'sm',
                minH: '26px',
            },
            lg: {
                fontSize: '13px',
                px: '3',
                h: '8',
                rounded: 'lg',
            },
            pill: {
                fontSize: '11.5px',
                px: '11px',
                h: '26px',
                rounded: 'full',
            },
        },
    },
    defaultVariants: {
        variant: 'subtle',
        size: 'sm',
    },
});
